import { LoadablePaint } from '@confluence/loadable';

export const ShareableLinkSpaceAdminControlsLoader = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ShareableLinkSpaceAdminControls" */ './components/ShareableLinkSpaceAdminControls.tsx'
			)
		).ShareableLinkSpaceAdminControls,
});
